"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));
/* eslint-disable max-len */


var NotificationUnfilled = function NotificationUnfilled() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "24",
    height: "23",
    viewBox: "0 2 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "notifications",
    clipPath: "url(#clip0_53477_4280)"
  }, /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask0_53477_4280",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "24",
    height: "24"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    id: "Bounding box",
    width: "24",
    height: "24",
    fill: "#D9D9D9"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask0_53477_4280)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    id: "vector",
    d: "M4.50003 18.8846V17.3847H6.30773V9.92308C6.30773 8.57821 6.72279 7.38912 7.55291 6.35578C8.38304 5.32245 9.44875 4.66156 10.75 4.37311V3.75003C10.75 3.40281 10.8714 3.10768 11.1143 2.86463C11.3571 2.62156 11.652 2.50003 11.9989 2.50003C12.3458 2.50003 12.641 2.62156 12.8846 2.86463C13.1282 3.10768 13.25 3.40281 13.25 3.75003V4.37311C14.5513 4.66156 15.617 5.32245 16.4471 6.35578C17.2772 7.38912 17.6923 8.57821 17.6923 9.92308V17.3847H19.5V18.8846H4.50003ZM11.9983 21.6923C11.5007 21.6923 11.0753 21.5153 10.7221 21.1613C10.3689 20.8073 10.1923 20.3817 10.1923 19.8846H13.8077C13.8077 20.3833 13.6305 20.8093 13.2762 21.1625C12.9218 21.5157 12.4959 21.6923 11.9983 21.6923ZM7.80768 17.3847H16.1923V9.92308C16.1923 8.76538 15.783 7.77724 14.9644 6.95866C14.1458 6.14006 13.1577 5.73076 12 5.73076C10.8423 5.73076 9.85416 6.14006 9.03558 6.95866C8.21698 7.77724 7.80768 8.76538 7.80768 9.92308V17.3847Z",
    fill: "#D97F00"
  }))), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_53477_4280"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};

var _default = NotificationUnfilled;
exports.default = _default;